import { get } from "lodash";
import { HoldingTypeEnum } from "../enum/holding-type.enum";
import { Owner } from "../polymer/Owner.model";
import { SolicitorTypeEnum } from "../enum/solicitor-type.enum";


export class ApplicationStep3{
  public holding_type                : HoldingTypeEnum | undefined;
  public is_holding_type_confirm     : boolean;
  public tenancy_in_common           : TenancyInCommon[];
  public attend_hdb_in_person        : boolean | undefined;
  public proposed_same_solicitor     : boolean | undefined;
  public outgoing_different_solicitor: boolean | undefined;
  
  public current_solicitor_type      : SolicitorTypeEnum | undefined;
  public proposed_solicitor_type     : SolicitorTypeEnum | undefined;
  public outgoing_solicitor_type     : SolicitorTypeEnum | undefined;
  
  public current                     : LegalRepresentation;
  public proposed                    : LegalRepresentation;
  public outgoing                    : LegalRepresentation;

  public valuation              : string;
  public estimated_market_value : string;
  public isRemission            : boolean;


  constructor(initial?: any) {
    this.holding_type                           = get(initial, "holding_type", undefined);
    this.attend_hdb_in_person                   = get(initial, "attend_hdb_in_person", undefined);
    this.is_holding_type_confirm                = get(initial, "is_holding_type_confirm", false);
    this.proposed_same_solicitor                = get(initial, "proposed_same_solicitor", false);
    this.outgoing_different_solicitor           = get(initial, "outgoing_different_solicitor", false);
    this.tenancy_in_common                      = get(initial, "tenancy_in_common", []);
    this.current_solicitor_type                 = get(initial, "current_solicitor_type", undefined);
    this.proposed_solicitor_type                = get(initial, "proposed_solicitor_type", undefined);
    this.outgoing_solicitor_type                = get(initial, "outgoing_solicitor_type", undefined);
    this.current                                = get(initial, "current", new LegalRepresentation(initial));
    this.proposed                               = get(initial, "proposed", new LegalRepresentation(initial));
    this.outgoing                               = get(initial, "outgoing", new LegalRepresentation(initial));
    this.valuation                              = get(initial, "valuation" , "");
    this.estimated_market_value                 = get(initial, "estimated_market_value", "");
    this.isRemission                            = get(initial, "isRemission" , false);
  }
}


export class TenancyInCommon{
  public shares : string | undefined;
  public user   :  Owner;
  
  constructor(initial?: any) {
    this.shares            = get(initial, "shares", undefined);
    this.user              = get(initial, "user", new Owner());
  }
}


export class LegalRepresentation{
  public hdb_solicitor                  : HDBSolicitor;
  public private_solicitor              : PrivateSolicitor;
  public conveyancing_private_solicitor : PrivateSolicitor;

  constructor(initial?:any){
    this.hdb_solicitor                  = get(initial, "hdb_solicitor", new HDBSolicitor(initial?.hdb_solicitor));
    this.private_solicitor              = get(initial, "private_solicitor", new PrivateSolicitor(initial?.private_solicitor));
    this.conveyancing_private_solicitor = get(initial, "conveyancing_private_solicitor", new PrivateSolicitor(initial?.conveyancing_private_solicitor));
  }
}




export class HDBSolicitor{
  
  public is_confirm       : boolean;
  public tnc              : boolean;
  public represented_same_solicitor : boolean;

  constructor(initial?: any) {
    this.is_confirm       = get(initial, "is_confirm", false);
    this.tnc              = get(initial, "tnc", false);
    this.represented_same_solicitor = get(initial, "represented_same_solicitor", false);
  }

}
export class PrivateSolicitor{
  
  public is_confirm                     : boolean;
  public uen                            : string;
  public name_of_firm                   : string;
  public email_of_solicitor             : string;
  public represented_same_solicitor     : boolean;

  constructor(initial?: any) {
    this.is_confirm                     = get(initial, "is_confirm", false);
    this.uen                            = get(initial, "uen", "");
    this.name_of_firm                   = get(initial, "name_of_firm", "");
    this.email_of_solicitor             = get(initial, "email_of_solicitor", "");
    this.represented_same_solicitor     = get(initial, "represented_same_solicitor", false);
  }

}






// export class SolicitorSegment {
//   public solicitor?: Solicitor[];
//   constructor(initial?: any) {
//     this.solicitor = get(initial, "solicitor", [new Solicitor()]); //Default will be one solicitor when select on Private Solicitor
//   }
// }

// export class ApplicationStep3 extends SolicitorSegment{
//   public solicitor_type?: SolicitorType = "";
//   public flat_valuation?: string = "";

//   constructor(initial?: any) {
//     super(initial);
//     this.solicitor_type = get(initial, "solicitor_type", "");
//     this.flat_valuation = get(initial, "flat_valuation", "");
//     // this.solicitor = get(initial, "solicitor", [new Solicitor()]); //Default will be one solicitor when select on Private Solicitor
//   }
// }

// export class Solicitor {
//   id?: string = "";
//   name?: string = "";
//   uin?: string = "";

//   constructor() {
//     let subString = () =>
//       ((1 + Math.random() * 0x10000) | 0).toString(36).substring(0, 2); //Radix 36, include 0-9,A-Z
//     this.id = subString() + subString() + subString() + subString();
//     this.name = "";
//     this.uin = "";
//   }
// }
